import { z } from 'zod';

// Výsledková tabuľka rozšíreného vyhľadávania (Týž. 19, druhá iterácia) — ľahká
// projekcia (nie celý Company blob) + celkový počet pre stránkovanie.
export const companySearchRowSchema = z.object({
  ico: z.string(),
  name: z.string().nullable(),
  city: z.string().nullable(),
  zip: z.string().nullable(),
  establishmentYear: z.string().nullable(),
  naceName: z.string().nullable(),
  latestRevenue: z.number().nullable(),
  latestNetIncome: z.number().nullable(),
  // Týž. 27 (user feedback 2026-07-19: FinStat porovnanie výsledkovej tabuľky
  // — "Aktíva" stĺpec).
  latestTotalAssets: z.number().nullable(),
  latestPeriod: z.number().nullable(),
  // Cachované rizikové skóre z companies.risk_score — null, kým ho prvé otvorenie
  // profilu neprepočíta; UI vtedy pill jednoducho nezobrazí.
  riskScore: z.number().nullable(),
});
export type CompanySearchRow = z.infer<typeof companySearchRowSchema>;

export const companySearchResponseSchema = z.object({
  results: z.array(companySearchRowSchema),
  total: z.number(),
  page: z.number(),
  pageSize: z.number(),
});
export type CompanySearchResponse = z.infer<typeof companySearchResponseSchema>;
